import React from 'react';
import { ProductDrawer } from './ProductDrawer';
import { CartDrawer } from './CartDrawer';

const Drawer = ({ product, isOpen, onClose, isCartBlocked, category }) => {
  const isNoVariant = product?.productVariants
    ? product?.productVariants?.length < 1
      ? true
      : false
    : true;

  if (isNoVariant) {
    return (
      <CartDrawer
        product={product}
        isOpen={isOpen}
        onClose={() => {
          onClose();
        }}
        isCartBlocked={isCartBlocked}
        category={category}
      />
    );
  } else {
    return (
      <ProductDrawer
        product={product}
        isOpen={isOpen}
        onClose={() => {
          onClose();
        }}
        isCartBlocked={isCartBlocked}
        category={category}
      />
    );
  }
};

export default Drawer;
